import NotificationMutedIcon from '@atlaskit/icon/core/notification-muted';
import * as React from 'react';

export function SvgBellOff() {
  return <NotificationMutedIcon label="" testId="ads-refreshed-icon" />;
}
